import { render, staticRenderFns } from "./ModalWorkpackages.vue?vue&type=template&id=58c774a6"
import script from "./ModalWorkpackages.vue?vue&type=script&lang=js"
export * from "./ModalWorkpackages.vue?vue&type=script&lang=js"
import style0 from "./ModalWorkpackages.vue?vue&type=style&index=0&id=58c774a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports